import { useState, useEffect } from "react";
import { Layout, Grid, Row } from "antd";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
// component
import ConsultationBanner from "./component/consultation_banner";
import ConsultationGeneralInfo from "./component/consultation_general_info";
import DialogConsultationAdd from "./dialog/dialog_consultation_add";
import DialogConsultationSuccess from "./dialog/dialog_consultation_success";
import DialogConsultationCancel from "./dialog/dialog_consultation_cancel";
// redux
import { getBranchBySlug } from "../../../store/branch/branch.action";

// strings
import { GENERAL_INFO, MAP } from "../../../store/data/data";
import "./style.css";
import { CONSULTATION } from "../../../store/data/group";

const { Content } = Layout;
const { useBreakpoint } = Grid;

const ConsultationScreen = () => {
  // -------------------------- VAR --------------------------
  const { branchSlug } = useParams();
  const screens = useBreakpoint();
  // -------------------------- STATE --------------------------
  const [open, setOpen] = useState(true);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);

  const [mobile, setMobile] = useState(false);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const group = CONSULTATION;
  // -------------------------- FUNCTION -----------------------

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(getBranchBySlug({ slug: branchSlug }));
  }, [branchSlug, dispatch]);

  useEffect(() => {
    if (screens?.xs) {
      setMobile(true);
    }
    if (screens?.sm) {
      setMobile(true);
    }
    if (screens?.md) {
      setMobile(true);
    }
    if (screens?.lg) {
      setMobile(false);
    }
    if (screens?.xl) {
      setMobile(false);
    }
    if (screens?.xxl) {
      setMobile(false);
    }
  }, [screens]);

  // -------------------------- RENDER --------------------------

  // Render Section Banner
  const renderSectionBanner = () => {
    return (
      <ConsultationBanner
        // data={GENERAL_INFO}
        setOpen={setOpen}
        mobile={mobile}
      />
    );
  };

  const renderMap = () => {
    return (
      <ConsultationGeneralInfo
        map={MAP}
        sample={GENERAL_INFO}
        mobile={mobile}
      />
    );
  };

  const renderModal = () => {
    return (
      <DialogConsultationAdd
        open={open}
        setOpenSuccess={setOpenSuccess}
        setOpen={setOpen}
        setOpenCancel={setOpenCancel}
        group={group}
      />
    );
  };

  const renderModalSuccess = () => {
    return (
      <DialogConsultationSuccess
        open={openSuccess}
        setOpenSuccess={setOpenSuccess}
      />
    );
  };

  const renderCancelPolicy = () => {
    return (
      <DialogConsultationCancel open={openCancel} setOpen={setOpenCancel} />
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="full">
      <Content className="home-content">
        <Row gutter={[0]}>
          {renderSectionBanner()}
          {renderMap()}
          {renderModal()}
          {renderModalSuccess()}
          {renderCancelPolicy()}
        </Row>
      </Content>
    </Layout>
  );
};

export default ConsultationScreen;
